import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
  } else {
    return {
      id: `vertical-tab-${index}`
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {
    "Bystronic Software": {
      jobTitle: "Software Global Support @",
      duration: "JUNE 2025 - PRESENT",
      desc: [
        "Oversee, troubleshoot, and enhance Bystronic’s global software solutions, providing second-level technical support to ensure stability and performance.",
        "Collaborate with development teams to investigate recurring issues, fix bugs, and improve the reliability of mission-critical applications.",
        "Provide technical guidance to first-level support, ensuring knowledge transfer, proper escalation, and creation of technical documentation.",
        "Monitor and optimize system performance, identify root causes, implement preventive measures, and participate in global projects for consistent updates and rollouts."
]
    },
    "Bilbomatica": {
      jobTitle: "Software Engineer @",
      duration: "SEPT 2022 - JUNE 2025",
      desc: [
        "Analyze and develop cutting-edge AI solutions, including the creation of an innovative virtual assistant to streamline the registration process for self-employed workers and company creation online.",
        "Apply advanced word classification processes and natural language processors to design a highly functional chatbot capable of understanding and responding effectively to user queries.",
        "Implement machine learning algorithms to continually improve the accuracy and efficiency of virtual assistants, ensuring an optimal user experience.",
        "Lead the migration, maintenance, and upgrade of key web applications, ensuring continuous improvements in usability and system performance."
      ]
    },
    "Redytel (2020-2022)": {
      jobTitle: "Software Engineer @",
      duration: "SEPT 2020 - SEPT 2022",
      desc: [
        "Analyze, develop, support, and maintain the iTUC Platform, a data automation system used by Osakidetza for integrating electromedical systems with electronic medical records.",
        "Develop the Sarbide project, a system designed for the Hospital de Galdakao, which manages access control, patient communication via SMS, and medical appointment reminders.",
        "Design and support an Android tablet application for the P.R.O.M. system to evaluate and modify patient treatment.",
        "Integrate and support electromedical devices through HL7 messaging communication and monitoring."
      ]
    },
    "Redytel (2019-2020)": {
      jobTitle: "Telecommunications Engineer @",
      duration: "FEB 2019 - SEPT 2020",
      desc: [
        "Led network expansion and renovation projects for hospitals, including the University Hospital of Cruces, the Hospital of Gorliz, and the Psychiatric Hospital of Zaldibar.",
        "Audited, re-planned, and migrated network nodes, including switches and cabling, and managed VLANs, IP addressing, and VoIP.",
        "Provided ongoing support for the LAN infrastructure at the Bilbao Exhibition Center (BEC).",
        "Installed and configured network equipment from multiple manufacturers, including Cisco, HP Aruba, and Huawei."
      ]
    },
    "Ikaskide Elkartea": {
      jobTitle: "Private Tutor @",
      duration: "MAY 2016 - FEB 2019",
      desc: [
        "Provided tutoring in subjects such as Mathematics, Physics, Chemistry, and Technology to primary and secondary school students.",
        "Prepared students for university entrance exams."
      ]
    }
  };




  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : null}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab key={key} label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel value={value} index={i} key={key}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map((descItem, i) => (
              <FadeInSection delay={`${i + 1}00ms`} key={`${descItem}-${i}`}>
                <li>{descItem}</li>
              </FadeInSection>
            ))}
          </ul>
        </TabPanel>
      ))}

    </div>
  );
};

export default JobList;
